import BlankCouponHistory from '@components/blank/BlankCouponHistory';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import PullToRefresh from '@components/PullToRefresh';
import styled from '@emotion/styled';

import useCouponHistories from './hooks/useCouponHistories';
import CouponFilter from '../../components/CouponFilter';
import CouponItem from '../../components/CouponItem';
import CouponItemSkeletons from '../../components/CouponItemSkeletons';

function CouponHistoryFragment() {
    const {
        coupons, isEmpty, fetchNextPage, isFetching, refetch,
    } = useCouponHistories();
    return (
        <PullToRefresh onRefresh={refetch}>
            <Column fullWidth>
                <CouponFilter tab='HISTORY'/>
                <Container fullWidth as='section'
                    align='center'
                    spacing={4}>
                    {coupons?.map((coupon) => (
                        <CouponItem coupon={coupon} isHistory key={ coupon.couponId} />
                    ))}
                    {isFetching && (<CouponItemSkeletons count={coupons?.length ? 1 : 5}/>)}
                </Container>
                <InfinityScrollTrigger trigger={fetchNextPage} />
                {(isEmpty && !isFetching) && (<BlankCouponHistory/>)}
            </Column>
        </PullToRefresh>
    );
}

const Container = styled(Column)`
    padding: 0 var(--spacing-4);
`;

export default CouponHistoryFragment;
